import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Row,
  Col,
  Button,
  Divider,
  message,
  Space,
} from "antd";

import {
  formItemLayout,
  tailFormItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
} from "../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
} from "../../utils/form_utilities";
import ReportHeading from "../../utils/ReportHeading";
import moment from "moment";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import axios from "axios";
import numberFormat from "../../utils/numberFormat";
import {
  addKeysToArray,
  onCustomerSearch,
  onWarehouseSearch,
  getStock,
  getWarehouse,
} from "../../utils/utilities";
import round from "../../utils/round";
import { sumBy } from "lodash";
import ReactToPrint from "react-to-print";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import numberFormatInt from "../../utils/numberFormatInt";
import { useCallback } from "react";

const { Content } = Layout;

const url = "/api/physical-counts/";
const title = "Daily Inventory Ledgers Report";

const initialValues = {
  period_covered: [moment(), moment()],
};
export default function DailyInventoryLedgerReport() {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    customers: [],
  });

  const report = useRef(null);

  const getReport = useCallback(({ period_covered, warehouse, is_excel }) => {
    if (period_covered && warehouse) {
      const form_data = {
        period_covered,
        warehouse,
        is_excel,
      };

      const loading = message.loading("Loading...");
      axios
        .post(`${url}daily-ledger-per-day`, form_data)
        .then((response) => {
          loading();
          if (is_excel) {
            return window.open(`/public/reports/${response.data.filename}`);
          }
        })
        .catch(() => {
          loading();
          message.error("There was an error processing your request");
        })
        .finally(() => setErrors({}));
    } else {
      setErrors({
        period_covered: period_covered ? "" : "Period Covered is Required",
        warehouse: warehouse ? "" : "Warehouse is Required",
      });
    }
  }, []);

  useEffect(() => {
    if (params?.date && params?.warehouse_id) {
      const date = new Date(params.date);
      const period_covered = [moment(date).subtract(1, "month"), moment(date)];
      getWarehouse(params.warehouse_id).then((warehouse) => {
        setState((prevState) => ({
          ...prevState,
          period_covered,
          warehouse,
        }));
      });
    }
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          padding: 24,
          minHeight: 280,
          borderRadius: 10,
        }}
      >
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              error={errors.period_covered}
              formItemLayout={smallFormItemLayout}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <SelectFieldGroup
              label="Warehouse"
              value={state.warehouse?.name}
              onFocus={() => {
                onWarehouseSearch({ value: "", setOptions });
              }}
              onSearch={(value) => onWarehouseSearch({ value, setOptions })}
              onChange={(index) => {
                const warehouse = options.warehouses?.[index] || null;
                onChange({
                  key: "warehouse",
                  value: warehouse,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              data={options.warehouses}
              column="name"
              error={errors.warehouse}
            />
          </Col>
        </Row>

        <Row>
          <Col span={12} offset={4}>
            <Form.Item className="field is-grouped">
              <Space>
                <Button
                  onClick={() => {
                    getReport({
                      ...state,
                      is_excel: true,
                    });
                  }}
                >
                  Download Excel
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Content>
  );
}
